module.exports = __webpack_public_path__ + "static/media/google-marker.9248613e.svg";